import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Dialog from 'Components/UI/Dialog';
import useMobileLayout from 'Hooks/useMobileLayout';
import classNames from 'classnames';
import MaterialDialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogContent';
import useResource from 'Hooks/useResource';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import EmailViewOnlyEditor from 'Components/Modals/ScheduleSendReview/EmailViewOnlyEditor';
import relationships from 'Consts/Relationships';
import { TemplatesProvider } from 'Context/TemplateContext';
import useUserContext from 'Context/UserContext';
import ScheduleSendReviewForm from './ScheduleSendReviewForm';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  emailForm: {
    marginRight: theme.spacing(2),
    flexGrow: 1,
  },
});

const ScheduleSendReview = ({
  classes,
  isOpen,
  closeModal,
  meetingAgendaResource,
  refreshResources,
}) => {
  const isMobile = useMobileLayout();
  const { resource, setResourceDeprecated: setResource } = useResource(meetingAgendaResource);
  const { resource: meetingResource, setResourceDeprecated: setMeetingResource } = useResource();
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [meetingTemplateCollection, setMeetingTemplateCollection] = useState(null);
  const { agentResource } = useUserContext();

  // eslint-disable-next-line no-unused-vars
  const [loadingMeetingTemplateCollectionError, setLoadingMeetingTemplateCollectionError] = useState(null);
  // const { setHouseholdId, householdLoading, clearHousehold } = useSimpleHousehold();

  const refreshMeetingTemplateCollection = async (meetingRes) => {
    try {
      const res = await meetingRes
        .relationship(relationships.personalEmailTemplates)
        .link('related')
        .get();

      setMeetingTemplateCollection(res);
      setLoading(false);
    } catch (err) {
      setLoadingMeetingTemplateCollectionError(err);
    }
  };

  const loadMeeting = async () => {
    if (!meetingAgendaResource?.relationship(fr.relationships.meeting.name)) {
      return;
    }
    setLoading(true);
    const meetingResponse = await meetingAgendaResource.relationship(fr.relationships.meeting.name).link('related')
      .get();
    setMeetingResource(meetingResponse.resources().head());
    // setHouseholdId(meetingResponse.resources().head().attr('householdId'));
    await refreshMeetingTemplateCollection(meetingResponse.resources().head());
    setLoading(false);
  };

  const handleOnClickEdit = async () => {
    await loadMeeting();
    setEdit(true);
  };

  useEffect(() => {
    loadMeeting();
  }, []);

  const handleClose = (e, forceClose) => {
    if (forceClose || !edit) {
      // clearHousehold();
      refreshResources();
      closeModal();
    }
    if (edit) {
      setEdit(false);
    }
  };

  if (!meetingResource) {
    return null;
  }

  return (
    <TemplatesProvider
      templatesLinkUrl={meetingResource?.relationship(fr.relationships.personalEmailTemplates.name).link('related').url()}
      pinnedTemplatesLinkUrl={agentResource?.relationship(fr.relationships.pinnedMeetingTemplates.name).link('related').url()}
    >
      <Dialog
        fullScreen={isMobile}
        onClose={handleClose}
        open={isOpen}
        maxWidth="lg"
        fullWidth
        disableEnforceFocus
      >
        <MaterialDialogContent
          className={classNames(classes.root)}
        >
          {loading && <LoadingIndicator />}
          {!loading && !edit && <ScheduleSendReviewForm meetingResource={meetingResource} meetingAgendaResource={meetingAgendaResource} onClickEdit={handleOnClickEdit} refreshResources={refreshResources} closeModal={closeModal} />}
          {!loading && edit && (
            <EmailViewOnlyEditor
              meetingResource={meetingResource}
              meetingAgenda={resource}
              meetingTemplateCollection={meetingTemplateCollection}
              onSaveMeetingTemplate={() => refreshMeetingTemplateCollection(meetingResource)}
              handleClose={handleClose}
              setMeetingAgenda={setResource}
              autosave={false}
              showSaveButton={false}
              confirmButtonText="Save"
              sendTypeOverride={'scheduled'}
              EditorProps={{
                agentOnly: true,
              }}
            />
          )}
        </MaterialDialogContent>
      </Dialog>
    </TemplatesProvider>
  );
};

ScheduleSendReview.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  meetingAgendaResource: PropTypes.object.isRequired,
  refreshResources: PropTypes.func.isRequired,
};

export default withStyles(styles)(ScheduleSendReview);
